import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RestrictedAccess } from "./PrivateComponent/RestrictedAccess";
import Login from "./authPages/Login";
import ServicePurchased from "./pages/servicesPurchased/ServicesPurchased";
import ManageProfile from "./pages/manageProfile/ManageProfile";
import IndustryCrmList from "./pages/industryCRM/IndustryCrmList";
import ContactFormEntries from "./pages/contactForm/ContactFormEntries";
import ContractorList from "./pages/contractors/ContractorList";
import JobApplication from "./pages/jobApplication/JobApplication";
import JobApplicationsList from "./pages/jobApplications/JobApplicationsList";
import Tools from "./pages/tools/Tools";
import Insurances from "./pages/insurances/Insurances";
import Subscriptions from "./pages/subscriptions/Subscriptions";
import Licenses from "./pages/licenses/Licenses";
import Vendor from "./pages/vendors/Vendor";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route exact path="/job-application" element={<JobApplication />} />
        <Route element={<RestrictedAccess />}>
          <Route exact path="/tools-purchased" element={<ServicePurchased />} />
          <Route exact path="/manage-profile" element={<ManageProfile />} />
          <Route exact path="/industry-crm" element={<IndustryCrmList />} />
          <Route exact path="/contact-form" element={<ContactFormEntries />} />
          <Route exact path="/contractors" element={<ContractorList />} />
          <Route
            exact
            path="/job-applications"
            element={<JobApplicationsList />}
          />
          <Route exact path="/tools" element={<Tools />} />
          <Route exact path="/insurances" element={<Insurances />} />
          <Route exact path="/subscriptions" element={<Subscriptions />} />
          <Route exact path="/licenses" element={<Licenses />} />
          <Route exact path="/vendors" element={<Vendor />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
